// personalization.js (CLEAN VERSION)
// - shows/hides text field
// - adds ONE linked personalization fee
// - removes fee when unchecked
// - no duplicates, no double-add, no race conditions

document.addEventListener("DOMContentLoaded", function () {
  const CHECKBOX_ID = "add-personalization";
  const TEXT_WRAPPER_ID = "personalization-text-wrapper";

  // Your fee variant ID
  const FEE_VARIANT_ID = 42755250552945;

  const checkbox = document.getElementById(CHECKBOX_ID);
  const textWrapper = document.getElementById(TEXT_WRAPPER_ID);

  if (!checkbox) return;

  // Get current parent variant
  function getCurrentVariantId() {
    const selectors = [
      'form[action="/cart"] input[name="id"][type="hidden"]',
      'form[action^="/cart"] input[name="id"][type="hidden"]',
      'form[action="/cart"] select[name="id"]',
      'form[action^="/cart"] select[name="id"]',
      'input[name="id"][type="hidden"]',
      'select[name="id"]'
    ];

    for (let sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.value) return parseInt(el.value, 10);
    }

    const form = document.querySelector('form[action^="/cart"]');
    if (form && form.dataset.variant) {
      return parseInt(form.dataset.variant, 10);
    }

    return null;
  }

  // Toggle text field
  if (textWrapper) {
    checkbox.addEventListener("change", () => {
      textWrapper.style.display = checkbox.checked ? "block" : "none";
    });
  }

  // Main checkbox → add/remove
  checkbox.addEventListener("change", () => {
    setTimeout(() => {
      if (checkbox.checked) {
        addFeeOnce();
      } else {
        removeFee();
      }
    }, 150);
  });

  // --- fixed: REMOVE problematic auto-add after submit ---
  // (This was causing the *second* fee add, so we removed it completely)

  // --------------------------
  // Add fee (NO duplicates)
  // --------------------------
  function addFeeOnce() {
    const parentVariantId = getCurrentVariantId();

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        // already exists?
        const exists = cart.items.some(item => {
          if (item.variant_id !== FEE_VARIANT_ID) return false;

          const linked =
            item.properties &&
            (item.properties._linked_parent || item.properties["_linked_parent"]);

          return linked && parseInt(linked, 10) === parentVariantId;
        });

        if (exists) return; // nothing to do

        // build fee
        const props = { "_Personalization Fee": "Yes" };
        if (parentVariantId) props["_linked_parent"] = String(parentVariantId);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: FEE_VARIANT_ID,
            quantity: 1,
            properties: props
          })
        });
      });
  }

  // --------------------------
  // Remove fee
  // --------------------------
  function removeFee() {
    const parentVariantId = getCurrentVariantId();

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const toRemove = [];

        cart.items.forEach((item, index) => {
          if (item.variant_id !== FEE_VARIANT_ID) return;

          const linked =
            item.properties &&
            (item.properties._linked_parent || item.properties["_linked_parent"]);

          if (linked && parseInt(linked, 10) === parentVariantId) {
            toRemove.push(index + 1);
          }
        });

        if (!toRemove.length) return;

        toRemove.forEach(line => {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ line: line, quantity: 0 })
          });
        });
      });
  }
});
